jQuery(document).ready(function ($) {




// // Store current selections
//     let savedSelections = {};

//     // Capture and store selected values
//     $('form[action="/cart/add"] select').on('change', function () {
//         const $this = $(this);
//         const optionName = $this.attr('name');
//         const optionValue = $this.val();

//         // Save the selected option
//         savedSelections[optionName] = optionValue;

//         // Delay to let Shopify's logic run, then restore the values
//         setTimeout(function () {
//             $('form[action="/cart/add"] select').each(function () {
//                 const $select = $(this);
//                 const name = $select.attr('name');
                
//                 if (savedSelections[name] && $select.val() !== savedSelections[name]) {
//                     $select.val(savedSelections[name]).trigger('change');
//                 }
//             });
//         }, 100);
//     });
});
